import { CommonModule } from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbService, BreadcrumbEntry } from '@services/breadcrumbService/breadcrumbService';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';
import {Subject, combineLatest, of} from "rxjs";
import {takeUntil, startWith, tap, switchMap} from "rxjs/operators";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'main-breadcrumb',
  templateUrl: './main-breadcrumb.component.html',
  styleUrls: ['./main-breadcrumb.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, BreadcrumbModule],
})
export class MainBreadcrumbComponent implements OnInit , OnDestroy {
  items: MenuItem[] = [];
  private destroy$ = new Subject<void>();

  constructor(
      private breadcrumbService: BreadcrumbService,
      private titleService: Title,
      private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.breadcrumbService.$breadcrumbs,
      this.translate.onLangChange.pipe(startWith({ lang: this.translate.currentLang })),
    ])
        .pipe(
          tap(([breadcrumbs]) => {
            this.items = this.buildBreadcrumbItems(breadcrumbs);
          }),
          switchMap(([breadcrumbs]) => {
            const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
            return lastBreadcrumb ? this.translate.get(lastBreadcrumb.label) : of('Masofa.Client.Angular');
          }),
          takeUntil(this.destroy$),
        )
        .subscribe(translatedTitle => {
          this.titleService.setTitle(translatedTitle);
        });
  }

  private buildBreadcrumbItems(breadcrumbs: BreadcrumbEntry[]): MenuItem[] {
    const homeBreadcrumb = {
      label: 'Home',
      routerLink: '/main-menu',
      disabled: false
    };

    const filteredBreadcrumbs = breadcrumbs.filter(b =>
      b.label !== 'Home' && b.label !== 'Main menu'
    );

    const breadcrumbItems = filteredBreadcrumbs.map((breadcrumb, index) => ({
      label: breadcrumb.label,
      routerLink: breadcrumb.url,
      disabled: index === filteredBreadcrumbs.length - 1
    }));

    return breadcrumbItems.length > 0 ? [homeBreadcrumb, ...breadcrumbItems] : [];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
